import { Container, Box } from "@mui/material";
import { range } from "ramda";
import { SwiperSlide } from "swiper/react";

import Placeholder from "components/Placeholder";
import { useScreen } from "hooks";

import "swiper/css";
import StyledSwiper from "../Styled/StyledSwiper";

const LoadingSkeleton = () => {
  const { isMobile } = useScreen();

  return (
    <Container data-testid="loading-skeleton">
      <Box mb={2} display="flex">
        <Placeholder variant="text" width={350} />
      </Box>
      <StyledSwiper slidesPerView="auto" slidesPerGroup={isMobile ? 2 : 4} spaceBetween={isMobile ? 10 : 16}>
        {range(0, 5).map((index) => (
          <SwiperSlide key={`carousel-skeleton-${index}`}>
            <Placeholder variant="rect" width={isMobile ? 112 : 214} height={isMobile ? 168 : 321} />
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </Container>
  );
};

export default LoadingSkeleton;
